import { lazy, Suspense } from 'react'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const ChatAECWidget = lazy(async () => {
  const module = await import('@/features/city-clerk/project-chat')
  return { default: module.ChatAECWidget }
})

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/projects/$projectId',
)({
  component: ProjectLayout,
})

// Layout for every project-scoped tab (permits, playground, reports, checks,
// document comparison...). Mounts the floating ChatAEC assistant once so it is
// available across all of them.
function ProjectLayout() {
  const { projectId } = Route.useParams()

  return (
    <>
      <Outlet />
      <Suspense fallback={null}>
        <ChatAECWidget projectId={projectId} />
      </Suspense>
    </>
  )
}
